import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import {
    IPrintWarrantyInput,
    IAccountData,
    PrintWarrantyErrors,
} from '../../../models/warranty-center';
import { IAccountBillTo } from '../../../models/account';
import { IPatientDevice } from '../../../models/device';
import { INameCode } from '../../../models/pro-sites';
import TextInput from '../../inputs/text-input';
import { IAccount } from '../../../models/company-account';
import SelectInput from '../../inputs/select-input';
interface IPrintWarrantyProps {
    userContactName: string;
    userEmailAddress: string;
    userPhoneNumber: string;
    billToAccounts: IAccountBillTo[] | null;
    accountData: IAccountData;
    deviceData: IPatientDevice | null;
    validating: boolean;
    updateFormData: (
        serialNumber: string,
        phoneNumber: string,
        shipToAccount: string,
        contactName: string
    ) => void;
    SetSerialNumber2Flag: (flag: boolean) => void;
    errors: PrintWarrantyErrors;
    country: string;
}

const PrintWarranty = ({
    userContactName,
    userEmailAddress,
    userPhoneNumber,
    billToAccounts,
    accountData,
    deviceData,
    validating,
    updateFormData,
    SetSerialNumber2Flag,
    errors,
    country,
}: IPrintWarrantyProps) => {
    const intl = useIntl();
    const [printWarrantyInputData, setPrintWarrantyInputData] =
        useState<IPrintWarrantyInput>({
            contactName: userContactName,
            phoneNumber: userPhoneNumber,
            emailAddress: userEmailAddress,
        });
    const [deviceLoaded, setDeviceLoaded] = useState(false);
    const [validSerialNumber, setValidSerialNumber] = useState(false);
    const [serialNumber1, setSerialNumber1] = useState('');
    const [lookingUpSerialNumber, setLookingUpSerialNumber] = useState(false);
    const [serialNumberError, setSerialNumberError] = useState(false);
    const [showSerialNumber2, setShowSerialNumber2] = useState(false);
    const [userAccountData, setUserAccountData] =
        useState<IAccountData>(accountData);
    const [billToAccount, setBillToAccount] = useState<string>();
    const [shipToAccount, setShipToAccount] = useState<string>('');
    const [contactName, setContactName] = useState(userContactName);
    const [phoneNumber, setPhoneNumber] = useState(userPhoneNumber);
    const [email, setEmail] = useState(userEmailAddress);
    const [isNuEar, setIsNuEar] = useState(
        window.location.href.includes('nuearpro')
    );
    const onBillToAccountChange = (event: any) => {
        const { name, value } = event.target;
        setBillToAccount(value);
    };
    const onShipToAccountChange = (event: any) => {
        const { name, value } = event.target;
        setShipToAccount(value);
    };
    const makeSerialNumber2Visible = () => {
        setShowSerialNumber2(true);
        SetSerialNumber2Flag(true);
    };

    const onSerialNumber1Change = (event: any) => {
        const { name, value } = event.target;
        setSerialNumber1(value);
    };
    const callUpdateFormData = () => {
        updateFormData(serialNumber1, phoneNumber, shipToAccount, contactName);
    };

    const unspecifiedError: any =
        'An unspecified error occurred submitting shipping label Request.';
    useEffect(() => {
        if (!errors) return;
    }, [errors]);
    useEffect(() => {
        if (deviceData !== null && deviceData !== undefined) {
            setLookingUpSerialNumber(false);
            if (deviceData.unavailable! || deviceData.device === null) {
                setSerialNumberError(true);
                setValidSerialNumber(false);
            } else {
                setLookingUpSerialNumber(false);
                setSerialNumberError(false);
                setValidSerialNumber(true);
                setPrintWarrantyInputData({
                    patientFirstName: deviceData.patientFirstName,
                    patientLastName: deviceData.patientLastName,
                    productClass: deviceData.device.productClass,
                    productType: deviceData.device.categoryProductType,
                    styleName: deviceData.device.starkeyStyle,
                    manufacturerName: deviceData.device.manufacturer,
                    serialNumber2:
                        deviceData.pairDevice !== null
                            ? deviceData.pairDevice.serialNumber
                            : '',
                    contactName: userContactName,
                    phoneNumber: userPhoneNumber,
                    emailAddress: userEmailAddress,
                });
            }
        }
    }, [deviceData]);

    const useLongFormat = (billToAccount: IAccountBillTo, country: string) => {
        const ibd: boolean =
            billToAccount.region === '10' ||
            billToAccount.region === '10SMP' ||
            (billToAccount.region !== null &&
                billToAccount.region.startsWith('IBD')) ||
            (billToAccount.customerCategory !== null &&
                billToAccount.customerCategory.startsWith('IBD'));
        const showCustomerCategory: boolean = country === 'US' && !ibd;
        return showCustomerCategory && billToAccount.customerCategory;
    };

    const billToListData = (accounts: IAccountBillTo[], country: string) => {
        const list: INameCode[] = [];
        for (const billToAccount of accounts) {
            let nameValue =
                billToAccount.fullAccountNumber +
                ' : ' +
                billToAccount.partyName;
            // eslint-disable-next-line react-hooks/rules-of-hooks
            if (useLongFormat(billToAccount, country)) {
                nameValue = nameValue + ' - ' + billToAccount.customerCategory;
            }

            list.push({
                name: nameValue,
                code: billToAccount.accountNumber,
            });
        }
        return list;
    };
    const shipToListData = (accounts: IAccount[]) => {
        const list: INameCode[] = [];
        for (const shipToAccount of accounts) {
            list.push({
                name:
                    shipToAccount.fullAccountNumber +
                    ' : ' +
                    shipToAccount.partyName +
                    ' , ' +
                    shipToAccount.street1,
                code: shipToAccount.accountNumber,
            });
        }
        return list;
    };

    useEffect(() => {
        if (billToAccounts !== null && billToAccounts !== undefined) {
            setUserAccountData({
                billToAccountsList: billToListData(billToAccounts, country),
                billToPartyName: billToAccounts[0].partyName,
                billToStreet1: billToAccounts[0].street1,
                billToCity: billToAccounts[0].city,
                billtoState: billToAccounts[0].state,
                billToPostalCode: billToAccounts[0].postalCode,
                shipToAccountsList: shipToListData(
                    billToAccounts[0].shipToAccounts
                ),
                shipToPartyName: billToAccounts[0].shipToAccounts[0].partyName,
                shipToStreet1: billToAccounts[0].shipToAccounts[0].street1,
                shipToCity: billToAccounts[0].shipToAccounts[0].city,
                shipToState: billToAccounts[0].shipToAccounts[0].state,
                shipToPostalCode:
                    billToAccounts[0].shipToAccounts[0].postalCode,
                contactName: userContactName,
                emailAddress: userEmailAddress,
                phoneNumber: userPhoneNumber,
            });
            setBillToAccount(billToAccounts[0].fullAccountNumber);
            setShipToAccount(
                billToAccounts[0].shipToAccounts[0].fullAccountNumber
            );
        }
    }, [billToAccounts]);

    useEffect(() => {
        const billTo = billToAccounts!.find(
            (b) => b.fullAccountNumber === billToAccount
        );
        if (billTo !== null) {
            const updatedValues = {
                billToPartyName: billTo!.partyName,
                billToStreet1: billTo!.street1,
                billToCity: billTo!.city,
                billtoState: billTo!.state,
                billToPostalCode: billTo!.postalCode,
                shipToAccountsList: shipToListData(billTo!.shipToAccounts),
                shipToPartyName: billTo!.shipToAccounts[0].partyName,
                shipToStreet1: billTo!.shipToAccounts[0].street1,
                shipToCity: billTo!.shipToAccounts[0].city,
                shipToState: billTo!.shipToAccounts[0].state,
                shipToPostalCode: billTo!.shipToAccounts[0].postalCode,
            };
            setUserAccountData((prevState) => {
                return { ...prevState, ...updatedValues };
            });
        }
    }, [billToAccount]);

    useEffect(() => {
        const billTo = billToAccounts!.find(
            (b) => b.fullAccountNumber === billToAccount
        );
        if (billTo !== null) {
            const shipTo = billTo!.shipToAccounts!.find(
                (s) => s.accountNumber === shipToAccount
            );
            const updatedValues = {
                shipToPartyName: shipTo!.partyName,
                shipToStreet1: shipTo!.street1,
                shipToCity: shipTo!.city,
                shipToState: shipTo!.state,
                shipToPostalCode: shipTo!.postalCode,
            };
            setUserAccountData((prevState) => {
                return { ...prevState, ...updatedValues };
            });
        }
    }, [shipToAccount]);

    const updateUserData = (event: any) => {
        switch (event.target.name) {
            case 'contactName':
                setContactName(event.target.value);
                printWarrantyInputData.contactName = event.target.value;
                break;
            case 'phoneNumber':
                setPhoneNumber(event.target.value);
                printWarrantyInputData.phoneNumber = event.target.value;
                break;
            case 'emailAddress':
                setEmail(event.target.value);
                printWarrantyInputData.emailAddress = event.target.value;
                break;
        }
    };
    const sendDataToParent = () => {
        updateFormData(serialNumber1, phoneNumber, shipToAccount, contactName);
    };
    return (
        <div>
            <h3 className={isNuEar ? 'nuEar gutter-top' : 'starkey gutter-top'}>
                {intl.formatMessage({
                    id: 'Warranty_Information',
                    defaultMessage: 'Warranty Information',
                })}
            </h3>
            <div className="form-horizontal">
                <div className="form-group">
                    <TextInput
                        name="serialNumber1"
                        label="SERIAL NUMBER 1 UPPER"
                        labelClassName="control-label col-sm-4"
                        fieldClassName="col-sm-8 col-md-6"
                        value={serialNumber1}
                        maxLength={30}
                        onChange={onSerialNumber1Change}
                        onBlur={() => {
                            if (serialNumber1) {
                                setLookingUpSerialNumber(true);
                                callUpdateFormData();
                                setShowSerialNumber2(false);
                                setDeviceLoaded(true);
                            }
                        }}
                        required={true}
                        error={errors.serialNumber1}
                        showError={true}
                    />

                    {lookingUpSerialNumber && (
                        <div className="col-sm-8 control-label">
                            <img src="/images/icons/loading.gif" />
                            <span>
                                {intl.formatMessage({
                                    id: 'Looking_up_serial_number',
                                    defaultMessage: 'Looking up serial number',
                                })}
                                ...
                            </span>
                        </div>
                    )}
                    {!lookingUpSerialNumber && serialNumberError && (
                        <div className="col-sm-8 control-label text-danger">
                            {intl.formatMessage({
                                id: 'Invalid_serial_number',
                                defaultMessage: 'Invalid serial number',
                            })}
                        </div>
                    )}
                </div>
                {printWarrantyInputData.serialNumber2 &&
                    !showSerialNumber2 &&
                    !lookingUpSerialNumber &&
                    !serialNumberError && (
                        <div className="form-group">
                            <a
                                className="col-sm-offset-4 col-sm-8"
                                onClick={makeSerialNumber2Visible}
                            >
                                {intl.formatMessage({
                                    id: 'Click_here_to_include_other_si',
                                    defaultMessage:
                                        'Click here to include other side',
                                })}
                                ({printWarrantyInputData.serialNumber2})
                            </a>
                        </div>
                    )}

                <div className="form-group">
                    <label className="control-label col-sm-4">
                        {intl.formatMessage({
                            id: 'SERIAL_NUMBER_2_UPPER',
                            defaultMessage: 'SERIAL NUMBER 2',
                        })}
                        :
                    </label>
                    {showSerialNumber2 && !lookingUpSerialNumber && (
                        <p className="form-control-static col-sm-8 col-md-6">
                            {printWarrantyInputData.serialNumber2}
                        </p>
                    )}
                </div>
                {validSerialNumber && !lookingUpSerialNumber && (
                    <div>
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                {intl.formatMessage({
                                    id: 'Manufacturer',
                                    defaultMessage: 'Manufacturer',
                                })}
                                :
                            </label>
                            <p className="form-control-static col-sm-8 col-md-6">
                                {printWarrantyInputData.manufacturerName}
                            </p>
                        </div>

                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                {intl.formatMessage({
                                    id: 'Patients_First_Name',
                                    defaultMessage: 'Patient’s First Name',
                                })}
                                :
                            </label>
                            <p className="form-control-static col-sm-8 col-md-6">
                                {printWarrantyInputData.patientFirstName}
                            </p>
                        </div>

                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                {intl.formatMessage({
                                    id: 'Patients_Last_Name',
                                    defaultMessage: 'Patient’s Last Name',
                                })}
                                :
                            </label>
                            <p className="form-control-static col-sm-8 col-md-6">
                                {printWarrantyInputData.patientLastName}
                            </p>
                        </div>

                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                {intl.formatMessage({
                                    id: 'Style',
                                    defaultMessage: 'Style',
                                })}
                                :
                            </label>
                            <p className="form-control-static col-sm-8 col-md-6">
                                {printWarrantyInputData.styleName}
                            </p>
                        </div>
                    </div>
                )}
            </div>
            <h3 className={isNuEar ? 'nuEar gutter-top' : 'starkey gutter-top'}>
                {intl.formatMessage({
                    id: 'Account_Information',
                    defaultMessage: 'Account Information',
                })}
            </h3>
            {userAccountData !== null && userAccountData !== undefined && (
                <div className="form-horizontal">
                    <div className="form-group">
                        <div>
                            <SelectInput
                                name="accountNumber"
                                label="Account Number"
                                labelClassName="control-label col-sm-4"
                                fieldClassName="col-sm-8 col-md-6"
                                options={
                                    userAccountData.billToAccountsList &&
                                    userAccountData.billToAccountsList!.map(
                                        (st) => ({
                                            value: st.code,
                                            text: st.name,
                                        })
                                    )
                                }
                                value={billToAccount}
                                hasDefaultOption={false}
                                onChange={onBillToAccountChange}
                                required={false}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label col-sm-4 hidden-xs">
                            {intl.formatMessage({
                                id: 'Address',
                                defaultMessage: 'Address',
                            })}
                            :
                        </label>
                        <p className="form-control-static col-sm-8 col-md-6">
                            <span>{userAccountData.billToPartyName}</span>
                            <br></br>
                            <span>{userAccountData.billToStreet1}</span>
                            <br></br>
                            <span>{userAccountData.billToCity}</span>,{' '}
                            <span>{userAccountData.billtoState}</span>{' '}
                            <span>{userAccountData.billToPostalCode}</span>
                        </p>
                    </div>

                    <div className="form-group">
                        <div>
                            <SelectInput
                                name="shipToAccount"
                                label="Ship To Account"
                                labelClassName="ontrol-label col-sm-4"
                                fieldClassName="col-sm-8 col-md-6"
                                options={
                                    userAccountData.shipToAccountsList &&
                                    userAccountData.shipToAccountsList.map(
                                        (st) => ({
                                            value: st.code,
                                            text: st.name,
                                        })
                                    )
                                }
                                value={shipToAccount}
                                hasDefaultOption={false}
                                onChange={onShipToAccountChange}
                                required={false}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label col-sm-4 hidden-xs">
                            {intl.formatMessage({
                                id: 'Address',
                                defaultMessage: 'Address',
                            })}
                            :
                        </label>
                        <p className="form-control-static col-sm-8 col-md-6">
                            <span>{userAccountData.shipToPartyName}</span>
                            <br></br>
                            <span>{userAccountData.shipToStreet1}</span>
                            <br></br>
                            <span>{userAccountData.shipToCity}</span>,{' '}
                            <span>{userAccountData.shipToState}</span>{' '}
                            <span>{userAccountData.shipToPostalCode}</span>
                        </p>
                    </div>

                    <div className="form-group">
                        <TextInput
                            name="contactName"
                            label="Contact Name"
                            labelClassName="control-label col-sm-4"
                            fieldClassName="col-sm-8 col-md-6"
                            value={printWarrantyInputData.contactName}
                            maxLength={25}
                            onChange={updateUserData}
                            onBlur={() => sendDataToParent()}
                            required={true}
                            error={errors.contactName}
                            showError={true}
                        />
                    </div>

                    <div className="form-group">
                        <TextInput
                            name="phoneNumber"
                            label="Phone Number"
                            labelClassName="ontrol-label col-sm-4"
                            fieldClassName="col-sm-8 col-md-6"
                            value={printWarrantyInputData.phoneNumber}
                            maxLength={20}
                            onChange={updateUserData}
                            onBlur={() => sendDataToParent()}
                            required={true}
                            error={errors.phoneNumber}
                            showError={true}
                        />
                    </div>

                    <div className="form-group">
                        <TextInput
                            name="emailAddress"
                            label="Email Address"
                            labelClassName="ontrol-label col-sm-4"
                            fieldClassName="col-sm-8 col-md-6"
                            value={printWarrantyInputData.emailAddress}
                            maxLength={30}
                            onChange={updateUserData}
                            onBlur={() => sendDataToParent()}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default PrintWarranty;
